module.exports = __webpack_public_path__ + "img/img-r.64adbd08.png";